module.exports = __webpack_public_path__ + "static/img/05.62861a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/05.jpg
// module id = BzxU
// module chunks = 1